// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Sidebar.css - Dark Slack-Style Theme */

/* ===== Dark Scrollbar ===== */
.dark-sidebar-scroll::-webkit-scrollbar {
  width: 4px;
}

.dark-sidebar-scroll::-webkit-scrollbar-track {
  background: transparent;
}

.dark-sidebar-scroll::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 4px;
}

.dark-sidebar-scroll::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.18);
}

/* Firefox scrollbar */
.dark-sidebar-scroll {
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.1) transparent;
}

/* ===== Sidebar Container ===== */
.sidebar {
  width: 260px;
  height: 100vh;
  background: #1a1d21;
  overflow-y: auto;
  overflow-x: hidden;
  transition: width 0.3s ease-in-out;
  position: fixed;
  top: 0;
  bottom: 0;
  padding-top: 0;
}

/* ===== Logo Area ===== */
.sidebar-logo-area {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 20px 16px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.sidebar-logo-area img {
  max-height: 32px;
  object-fit: contain;
  filter: brightness(1.1);
}

.sidebar-logo-text {
  font-size: 0.95rem;
  font-weight: 700;
  color: #ffffff;
  letter-spacing: 0.3px;
  white-space: nowrap;
}

/* ===== Section Headers ===== */
.sidebar-section-header {
  text-transform: uppercase;
  letter-spacing: 1.2px;
  font-size: 0.65rem !important;
  color: rgba(255, 255, 255, 0.4) !important;
  font-weight: 600 !important;
  padding: 16px 16px 4px 16px;
  -webkit-user-select: none;
          user-select: none;
}

/* ===== Parent Menu Items ===== */
.sidebar-item {
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  transition: all 0.15s ease;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.7);
  border-radius: 8px;
}

.sidebar-item .MuiListItemText-primary {
  font-size: 0.8125rem !important;
  white-space: normal !important;
  overflow: visible !important;
  text-overflow: unset !important;
  line-height: 1.35 !important;
}

.sidebar-item:hover {
  background-color: rgba(255, 255, 255, 0.06);
}

.sidebar-item:hover .MuiListItemText-primary {
  color: #ffffff !important;
}

.sidebar-item:hover .MuiListItemIcon-root svg {
  color: rgba(255, 255, 255, 0.7) !important;
}

/* ===== Active Parent State ===== */
.sidebar-item.active-parent {
  background-color: rgba(102, 126, 234, 0.15) !important;
  border-left: 3px solid #667eea;
}

.sidebar-item.active-parent .MuiListItemText-primary {
  color: #ffffff !important;
  font-weight: 600 !important;
}

.sidebar-item.active-parent .MuiListItemIcon-root svg {
  color: #667eea !important;
}

/* ===== Active Item (standalone) ===== */
.active-item {
  background-color: rgba(102, 126, 234, 0.15) !important;
  border-left: 3px solid #667eea;
}

.active-item .MuiListItemIcon-root svg {
  color: #667eea !important;
}

.active-item .MuiListItemText-primary {
  color: #ffffff !important;
  font-weight: 600 !important;
}

/* ===== Child / Sub Items ===== */
.sidebar-subitem {
  cursor: pointer;
  transition: all 0.15s ease;
  position: relative;
}

.sidebar-subitem .MuiListItemText-primary {
  font-size: 0.775rem !important;
  white-space: normal !important;
  overflow: visible !important;
  text-overflow: unset !important;
  line-height: 1.3 !important;
}

.sidebar-subitem:hover {
  background-color: rgba(255, 255, 255, 0.04) !important;
}

.sidebar-subitem:hover .MuiListItemText-primary {
  color: rgba(255, 255, 255, 0.9) !important;
}

/* ===== Child dot indicator ===== */
.child-dot {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.25);
  flex-shrink: 0;
  transition: background 0.15s ease;
}

.child-dot.active {
  background: #667eea;
  box-shadow: 0 0 6px rgba(102, 126, 234, 0.5);
}

/* ===== Expand/Collapse Icons ===== */
.sidebar-chevron {
  color: rgba(255, 255, 255, 0.3) !important;
  font-size: 18px !important;
  transition: transform 0.2s ease, color 0.15s ease;
}

.sidebar-chevron.open {
  color: rgba(255, 255, 255, 0.5) !important;
}

/* ===== Icon Styling ===== */
.sidebar .MuiListItemIcon-root {
  min-width: 28px;
}

.sidebar .MuiListItemIcon-root svg {
  font-size: 18px;
  color: rgba(255, 255, 255, 0.5);
  transition: color 0.15s ease;
}

/* ===== Collapse Animation ===== */
.MuiCollapse-root {
  transition-duration: 200ms !important;
}

/* ===== Mobile Drawer Backdrop ===== */
.dark-sidebar-backdrop .MuiBackdrop-root {
  background-color: rgba(0, 0, 0, 0.6) !important;
  backdrop-filter: blur(4px);
}

/* ===== Responsive ===== */
@media (max-width: 600px) {
  .sidebar {
    width: 260px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/common/Sidebar.css"],"names":[],"mappings":"AAAA,yCAAyC;;AAEzC,+BAA+B;AAC/B;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;AACvC;;AAEA,sBAAsB;AACtB;EACE,qBAAqB;EACrB,qDAAqD;AACvD;;AAEA,kCAAkC;AAClC;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,kCAAkC;EAClC,eAAe;EACf,MAAM;EACN,SAAS;EACT,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,kDAAkD;AACpD;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA,gCAAgC;AAChC;EACE,yBAAyB;EACzB,qBAAqB;EACrB,6BAA6B;EAC7B,0CAA0C;EAC1C,2BAA2B;EAC3B,2BAA2B;EAC3B,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,0BAA0B;EAC1B,eAAe;EACf,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;EAC9B,4BAA4B;EAC5B,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;AAC5C;;AAEA,oCAAoC;AACpC;EACE,sDAAsD;EACtD,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,yCAAyC;AACzC;EACE,sDAAsD;EACtD,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA,kCAAkC;AAClC;EACE,eAAe;EACf,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,8BAA8B;EAC9B,4BAA4B;EAC5B,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,0CAA0C;AAC5C;;AAEA,oCAAoC;AACpC;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,qCAAqC;EACrC,cAAc;EACd,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA,sCAAsC;AACtC;EACE,0CAA0C;EAC1C,0BAA0B;EAC1B,iDAAiD;AACnD;;AAEA;EACE,0CAA0C;AAC5C;;AAEA,6BAA6B;AAC7B;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA,mCAAmC;AACnC;EACE,qCAAqC;AACvC;;AAEA,uCAAuC;AACvC;EACE,+CAA+C;EAC/C,0BAA0B;AAC5B;;AAEA,2BAA2B;AAC3B;EACE;IACE,YAAY;EACd;AACF","sourcesContent":["/* Sidebar.css - Dark Slack-Style Theme */\n\n/* ===== Dark Scrollbar ===== */\n.dark-sidebar-scroll::-webkit-scrollbar {\n  width: 4px;\n}\n\n.dark-sidebar-scroll::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.dark-sidebar-scroll::-webkit-scrollbar-thumb {\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 4px;\n}\n\n.dark-sidebar-scroll::-webkit-scrollbar-thumb:hover {\n  background: rgba(255, 255, 255, 0.18);\n}\n\n/* Firefox scrollbar */\n.dark-sidebar-scroll {\n  scrollbar-width: thin;\n  scrollbar-color: rgba(255, 255, 255, 0.1) transparent;\n}\n\n/* ===== Sidebar Container ===== */\n.sidebar {\n  width: 260px;\n  height: 100vh;\n  background: #1a1d21;\n  overflow-y: auto;\n  overflow-x: hidden;\n  transition: width 0.3s ease-in-out;\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  padding-top: 0;\n}\n\n/* ===== Logo Area ===== */\n.sidebar-logo-area {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 20px 16px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.sidebar-logo-area img {\n  max-height: 32px;\n  object-fit: contain;\n  filter: brightness(1.1);\n}\n\n.sidebar-logo-text {\n  font-size: 0.95rem;\n  font-weight: 700;\n  color: #ffffff;\n  letter-spacing: 0.3px;\n  white-space: nowrap;\n}\n\n/* ===== Section Headers ===== */\n.sidebar-section-header {\n  text-transform: uppercase;\n  letter-spacing: 1.2px;\n  font-size: 0.65rem !important;\n  color: rgba(255, 255, 255, 0.4) !important;\n  font-weight: 600 !important;\n  padding: 16px 16px 4px 16px;\n  user-select: none;\n}\n\n/* ===== Parent Menu Items ===== */\n.sidebar-item {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  cursor: pointer;\n  transition: all 0.15s ease;\n  font-size: 13px;\n  color: rgba(255, 255, 255, 0.7);\n  border-radius: 8px;\n}\n\n.sidebar-item .MuiListItemText-primary {\n  font-size: 0.8125rem !important;\n  white-space: normal !important;\n  overflow: visible !important;\n  text-overflow: unset !important;\n  line-height: 1.35 !important;\n}\n\n.sidebar-item:hover {\n  background-color: rgba(255, 255, 255, 0.06);\n}\n\n.sidebar-item:hover .MuiListItemText-primary {\n  color: #ffffff !important;\n}\n\n.sidebar-item:hover .MuiListItemIcon-root svg {\n  color: rgba(255, 255, 255, 0.7) !important;\n}\n\n/* ===== Active Parent State ===== */\n.sidebar-item.active-parent {\n  background-color: rgba(102, 126, 234, 0.15) !important;\n  border-left: 3px solid #667eea;\n}\n\n.sidebar-item.active-parent .MuiListItemText-primary {\n  color: #ffffff !important;\n  font-weight: 600 !important;\n}\n\n.sidebar-item.active-parent .MuiListItemIcon-root svg {\n  color: #667eea !important;\n}\n\n/* ===== Active Item (standalone) ===== */\n.active-item {\n  background-color: rgba(102, 126, 234, 0.15) !important;\n  border-left: 3px solid #667eea;\n}\n\n.active-item .MuiListItemIcon-root svg {\n  color: #667eea !important;\n}\n\n.active-item .MuiListItemText-primary {\n  color: #ffffff !important;\n  font-weight: 600 !important;\n}\n\n/* ===== Child / Sub Items ===== */\n.sidebar-subitem {\n  cursor: pointer;\n  transition: all 0.15s ease;\n  position: relative;\n}\n\n.sidebar-subitem .MuiListItemText-primary {\n  font-size: 0.775rem !important;\n  white-space: normal !important;\n  overflow: visible !important;\n  text-overflow: unset !important;\n  line-height: 1.3 !important;\n}\n\n.sidebar-subitem:hover {\n  background-color: rgba(255, 255, 255, 0.04) !important;\n}\n\n.sidebar-subitem:hover .MuiListItemText-primary {\n  color: rgba(255, 255, 255, 0.9) !important;\n}\n\n/* ===== Child dot indicator ===== */\n.child-dot {\n  width: 5px;\n  height: 5px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.25);\n  flex-shrink: 0;\n  transition: background 0.15s ease;\n}\n\n.child-dot.active {\n  background: #667eea;\n  box-shadow: 0 0 6px rgba(102, 126, 234, 0.5);\n}\n\n/* ===== Expand/Collapse Icons ===== */\n.sidebar-chevron {\n  color: rgba(255, 255, 255, 0.3) !important;\n  font-size: 18px !important;\n  transition: transform 0.2s ease, color 0.15s ease;\n}\n\n.sidebar-chevron.open {\n  color: rgba(255, 255, 255, 0.5) !important;\n}\n\n/* ===== Icon Styling ===== */\n.sidebar .MuiListItemIcon-root {\n  min-width: 28px;\n}\n\n.sidebar .MuiListItemIcon-root svg {\n  font-size: 18px;\n  color: rgba(255, 255, 255, 0.5);\n  transition: color 0.15s ease;\n}\n\n/* ===== Collapse Animation ===== */\n.MuiCollapse-root {\n  transition-duration: 200ms !important;\n}\n\n/* ===== Mobile Drawer Backdrop ===== */\n.dark-sidebar-backdrop .MuiBackdrop-root {\n  background-color: rgba(0, 0, 0, 0.6) !important;\n  backdrop-filter: blur(4px);\n}\n\n/* ===== Responsive ===== */\n@media (max-width: 600px) {\n  .sidebar {\n    width: 260px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
